export default __webpack_public_path__ + "images/onboarding/splashverse-onboarding-math-69c60eb9be85e68e29fedd84674add3b.png";